import {
    Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Input Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Type of the input
     */
    @Prop({ default: 'text' }) type!: string;

    /**
     * Make input direction RTL, LTR, Center, or Auto
     */
    @Prop({ default: 'auto' }) dir!: string;

    /**
     * Set the Align of the Input
     */
    @Prop() align!: string;

    /**
     * Maximum Character Limit
     * This Prop show the character limit
     */
    @Prop() maxChar!: string | number;

    /**
     * Maximum Character Length
     * This Prop doesn't show the character limit
     */
    @Prop() maxLength!: string | number;

    /**
     * Icon Prepend
     */
    @Prop({ type: String }) iconPrepend!: string;

    /**
     * Icon Prepend Action
     */
    @Prop({ type: Function }) iconPrependAction!: Function;

    /**
     * Icon Append
     */
    @Prop({ type: String }) iconAppend!: string;

    /**
     * Icon Append Action
     */
    @Prop({ type: Function }) iconAppendAction!: Function;

    /**
     * Addon Prepend
     */
    @Prop({ type: String }) addonPrepend!: string;

    /**
     * Addon Append
     */
    @Prop({ type: String }) addonAppend!: string;

    /**
     * Clear input
     */
    @Prop({ type: Boolean }) clearable!: boolean;

    /**
     * Clear input icon
     */
    @Prop({ type: String, default: 'times' }) clearableIcon!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) iconLibrary!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) iconPrefix!: string;

    /**
     * Input should accept decimal number
     */
    @Prop({ type: Boolean }) decimal!: boolean;

    /**
     * decimal Character
     * Accepts: '/' or '.'
     */
    @Prop({ default: '.' }) decimalChar!: string;

    /**
     * Thousand Separator
     * Accepts: '/' or '.'
     */
    @Prop({ default: ',' }) thousandsSeparator!: string;

    /**
     * Format of the input
     */
    @Prop() format!: string;
}

export default Props;
